export const DELIVERY_STATUS_WAITING = 0;

export const DELIVERY_STATUS_OPTIONS = [
  { value: 0, label: 'Chờ (Chưa Giao)' },
  { value: 3, label: 'Gấp' },
  { value: 4, label: 'Còn đơn tiếp theo' },
  { value: 5, label: 'Có đơn trước đó' },
  { value: 1, label: 'Đã bàn giao' }
] as const;

export function deliveryStatusLabel(status: number | null | undefined): string {
  switch (Number(status)) {
    case 1:
      return 'Đã bàn giao';
    case 3:
      return 'Gấp';
    case 4:
      return 'Còn đơn tiếp theo';
    case 5:
      return 'Có đơn trước đó';
    case 0:
    case 2:
    default:
      return 'Chờ (Chưa Giao)';
  }
}

export function deliveryStatusTone(status: number | null | undefined): number {
  return Number(status) === 2 ? 0 : Number(status) || 0;
}

export function deliveryStatusOptions(currentStatus: number) {
  return DELIVERY_STATUS_OPTIONS.map((option) =>
    option.value === DELIVERY_STATUS_WAITING && currentStatus === 2
      ? { ...option, value: 2 }
      : option
  );
}
